<template>
  <div class="icon_giftcard flex">
    <figure :style="'background-image: url(' + logoLight + ')'"></figure>
    <hgroup>
      <h4>
        <!-- <currency :value="product.GiftCardAmount" />&nbsp;Giftcard -->
        Giftcard
      </h4>
      <cite>{{ name }}</cite>
      <cite>{{ email }}</cite>
    </hgroup>
  </div>
</template>

<script>
//import func from "../../vue-temp/vue-editor-bridge";
import { mapState, mapGetters } from "vuex";

export default {
  name: "CartIconGiftCard",
  props: ["product"],
  computed: {
    ...mapState(["client"]),
    ...mapGetters(["logoLight"]),

    name: function() {
      return this.product.RecipientName;
    },
    email: function() {
      return this.product.RecipientEmail;
    }
  }
};
</script>

<style></style>
